module.exports = __webpack_public_path__ + "img/logo-sm.98d6f84c.png";